export class Point {
  id: number;
  xCoord: number;
  yCoord: number;
  radius: number;
  mainRadius: number;
  color: string;
  mainColor: string;
  name: string;

  constructor(
    id: number,
    xCoord: number,
    yCoord: number,
    name: string,
    color: string
  ) {
    this.id = id;
    this.xCoord = xCoord;
    this.yCoord = yCoord;
    this.radius = 10;
    this.mainRadius = 10;
    this.color = color;
    this.mainColor = color;
    this.name = name;
  }

  getCoords(): [number, number] {
    return [this.xCoord, this.yCoord];
  }
}
